import React from 'react';
import Breadcrumbs from '../components/Breadcrumbs';

export default function Privatlivspolitik() {
  return (
    <div className="customer-legal-page">
      <Breadcrumbs 
        items={[
          { label: 'Forside', path: '/' },
          { label: 'Privatlivspolitik' }
        ]} 
      />
      <div className="container mx-auto px-6 py-16">
        <div className="max-w-4xl mx-auto prose prose-lg">
          <h1 className="text-4xl font-bold mb-8">Privatlivspolitik for kunder</h1>
          
          <p>Denne privatlivspolitik beskriver, hvordan Enkelt Energi ApS (CVR-nr. 44925702) (herefter "Leverandøren") behandler personoplysninger om sine kunder, og hvilke rettigheder kunderne har i den henseende.</p>
          
          <h2>1. Dataansvarlig</h2>
          
          <p>Leverandøren er dataansvarlig for behandlingen af de personoplysninger, som vi har modtaget om dig som kunde som led i opfyldelse af vores aftale med dig om salg af elektricitet.</p>
          
          <p>Vi kan kontaktes via følgende oplysninger:</p>
          
          <p>Adresse: Bryghuspladsen 8, 1473 København K</p>
          
          <p>Telefonnr.: +45 70 60 80 07</p>
          
          <p>Mail: hej@enkelenergi.dk</p>
          
          <p>Hvis du har spørgsmål om vores behandling af dine personoplysninger, er du til enhver tid velkommen til at kontakte os herom.</p>
          
          <h2>2. Vi behandler følgende oplysninger om dig</h2>
          
          <p>Leverandøren kan behandle følgende personoplysninger om dig som kunde i forbindelse med Aftalen:</p>
          
          <p>Almindelige oplysninger relateret til aftalen om levering af elektricitet, herunder kundens kontaktoplysninger, produktoplysninger, aftagenummer, målenummer, bank- og betalingsoplysninger, kreditværdighed, klagesager, statistiske afvigelser, driftsdata, forbrugsrelaterede data og overtrædelser relateret til Leverandørens ydelser (tyveri af strøm).</p>
          
          <p>Almindelige oplysninger til brug for varetagelse af forpligtelser efter lovgivningen, herunder forhold vedrørende dyrehold, børn eller hjælpeløse personer, hvis dette er relevant.</p>
          
          <p>Følsomme oplysninger og andre oplysninger i forbindelse med afbrydelser af elforsyningen, herunder helbredsoplysninger og forhold, der giver anledning til overvejelser om sikkerheden for Leverandørens ansatte eller for personer, der varetager Leverandørens interesser.</p>
          
          <p>CPR-nummer til brug for anmeldelse i datahubben samt til brug for administration af aftaleforholdet.</p>
          
          <p>Almindelige oplysninger til brug for varetagelse af forpligtelser efter lovgivningen, herunder bogføringsloven.</p>
          
          <p><strong>Yderligere oplysninger specifikt relateret til opladningstjenester:</strong></p>
          
          <p>Almindelige oplysninger relateret til aftaler om l salg, leje, installation, drift- og service af ladebokse, herunder kundens kontaktoplysninger, produktoplysninger, aftagenummer, målenummer, oplysninger om elvarme og egenproduktion af el, bank- og betalingsoplysninger, kreditværdighed, klagesager, driftsdata, forbrugsrelaterede data, afgiftsforhold og overtrædelser relateret til Leverandørens ydelser (tyveri af strøm).</p>
          
          <p>IP-adresser, e-mailadresser (til autentifikation), ladeoplysninger (tidspunkt, mængde), og Charger's Open Charge Point Protocol (OCPP).</p>
          
          <p>Vi behandler ligeledes cookies om besøgende på vores hjemmeside, se nærmere i vores cookiepolitik</p>
          
          <h2>3. Formål med behandling og retsgrundlag</h2>
          
          <p>Formålet med behandlingen af personoplysningerne er følgende:</p>
          
          <p>Levering af elektricitet.</p>
          
          <p>Administration af aftalen om levering af elektricitet, herunder fakturering og afregning.</p>
          
          <p>Afbrydelser af elforsyning.</p>
          
          <p>Kommunikation med netselskab/foged/myndigheder ifbm. eventuel afbrydelse af elforsyning.</p>
          
          <p><strong>Yderligere formål specifikt relateret til opladningstjenester:</strong></p>
          
          <p>Administration af opladningstjenester: Behandling af personoplysninger for at sikre adgang til og brug af ladestandere, inkl. aktivering og deaktivering af opladning samt styring af opladningsperioder.</p>
          
          <p>Kontrol og optimering af opladning: Indsamling og brug af data fra ladestandere med henblik på effektiv styring af energiforbruget og optimering af opladningsprocesser, baseret på brugerens forbrugsmønstre og netforhold.</p>
          
          <p>Behandling af elafgift refusion: Registrering og dokumentation af nødvendige oplysninger til myndighederne for at opnå refusion af elafgift i forbindelse med opladningstjenester.</p>
          
          <p>Brugerkommunikation: Kontakt med kunder vedrørende driftsopdateringer, fakturaer og afregningsdetaljer for opladningstjenester.</p>
          
          <p>Leverandøren behandler kun personoplysninger i det omfang, det er nødvendigt for at opfylde de formål, hvortil oplysningerne er indsamlet.</p>
          
          <p>Behandlingen sker efter følgende retsgrundlag:</p>
          
          <p>At behandling er nødvendig af hensyn til opfyldelse af en kontrakt, som kunden er part i, jf. artikel 6, stk. 1, litra b i databeskyttelsesforordningen, jf. databeskyttelseslovens § 6.</p>
          
          <p>At behandlingen er nødvendig af hensyn til overholdelse af retlige forpligtelser, jf. artikel 6, stk. 1, litra c i databeskyttelsesforordningen, jf. databeskyttelseslovens § 6.</p>
          
          <p>At kunden eventuelt har samtykket til behandlingen, jf. artikel 6, stk. 1, litra a og art. 7, stk. 2, litra a i databeskyttelsesforordningen, jf. databeskyttelseslovens § 6.</p>
          
          <p>At behandlingen er nødvendig for at beskytte kunden eller en anden fysisk persons vitale interesser, hvis de ikke selv er i stand til at give et samtykke, jf. artikel 9, stk. 2, litra c i databeskyttelsesforordningen.</p>
          
          <p>At behandlingen er nødvendig for, at et retskrav kan fastlægges, gøres gældende eller forsvares, jf. artikel 9, stk. 2, litra f i databeskyttelsesforordningen.</p>
          
          <p>At behandlingen ud fra hensynet til interessen i at et eventuelt retskrav skal kunne fastlægges, gøres gældende eller forsvares efter en interesseafvejning går forud for kundens grundlæggende rettigheder og frihedsrettigheder, jf. artikel 6, stk. 1, litra f i databeskyttelsesforordningen (den såkaldte interesseafvejningsregel).</p>
          
          <p>Behandlingen af CPR-numre sker når det kræves af lovgivningen i form af bl.a. markedsforskrifterne udstedt af Energinet, i henhold til databeskyttelseslovens § 11, stk. 2. nr. 1 samt når behandlingen sker på grundlag af et samtykke fra kunden i henhold til § 11, stk. 2, nr. 2 i databeskyttelsesloven.</p>
          
          <h2>4. Markedsføring, analyse og kundeadministration</h2>
          
          <p>Vi kan behandle kunders almindelige kontaktoplysninger og tekniske identifikatorer (fx e-mailadresse, telefonnummer, kunde-ID og online identifikatorer) til brug for markedsføring, analyse og kundeadministration på tværs af Leverandørens systemer og kanaler.</p>
          
          <p>Oplysningerne kan anvendes til:</p>
          <ul>
            <li>målretning og visning af markedsføringsindhold på digitale kanaler</li>
            <li>måling af effekt og relevans af markedsføringsaktiviteter</li>
            <li>vedligeholdelse og anvendelse af kunde- og CRM-systemer</li>
            <li>segmentering, aggregeret analyse og statistiske formål</li>
          </ul>
          
          <p>Hvor det er relevant, behandles oplysningerne i pseudonymiseret eller aggregeret form, herunder ved brug af tekniske foranstaltninger som hashing, inden de anvendes i eksterne systemer eller platforme.</p>
          
          <p>Behandlingen sker alene på baggrund af kundens samtykke eller andet gyldigt behandlingsgrundlag efter databeskyttelsesforordningen. Kunden kan til enhver tid gøre indsigelse mod eller trække sit samtykke tilbage i overensstemmelse med gældende regler.</p>
          
          <h2>5. Opbevaring af oplysninger</h2>
          
          <p>Kundens personoplysninger opbevares 3 år efter afsluttet kundeforhold eller længere tid, hvis påkrævet efter lovgivningen. Således opbevares oplysninger, der er en del af regnskabsmateriale i fem år plus indeværende regnskabsår i overensstemmelse med bogføringsloven samt oplysninger om forbrug, der anvendes til statistiske formål.</p>
          
          <p>Følsomme personoplysninger, jf. databeskyttelsesforordningens artikel 9, opbevares så længe de er relevante og nødvendige i forbindelse med en afbrydelse, samt så længe det er relevant og nødvendigt af hensyn til den enkelte kundes eller medarbejders sikkerhed.</p>
          
          <p>Oplysninger om eventuelle lovovertrædelser slettes, efter oplysningerne er videregivet til relevante myndighed.</p>
          
          <h2>6. Videregivelse af oplysninger</h2>
          
          <p>Leverandøren videregiver personoplysninger til følgende kategorier af modtagere:</p>
          
          <p><strong>Datahubben:</strong> Der videregives personoplysninger som navn, adresse, målerdata og CPR-nummer via DataHubben, som ejes og drives af Energinet, idet det er påkrævet efter markedsforskrifter udstedt af Energinet.</p>
          
          <p><strong>Kommuner:</strong> Får Leverandøren kendskab til, at et barn eller en ung under 18 år lever under forhold, der bringer dets sundhed eller udvikling i fare, sørger Leverandøren for, at kommunen underrettes herom i overensstemmelse med lov om social service.</p>
          
          <p><strong>Politiet:</strong> Får Leverandøren kendskab til, at dyrehold behandles uforsvarligt, sørger Leverandøren for, at politiet underrettes herom.</p>
          
          <p><strong>Netselskaber:</strong> I sager om afbrydelse af elforsyninger videregives personoplysninger i det omfang, det er et nødvendigt led i kommunikationen mellem Leverandøren og netselskabet.</p>
          
          <p><strong>Advokat og gældsinddrivelsesvirksomheder:</strong> I forbindelse med at der opstår behov for juridisk bistand i forbindelse med fx tvister og inddrivelse, vil relevante oplysninger kunne videregives.</p>
          
          <p><strong>Offentlige myndigheder:</strong> Offentlige myndigheder kan i forbindelse med deres virke anmode om og pålægge Leverandøren at udlevere personoplysninger. Det kan eksempelvis være skattemyndighederne, som kan have behov for disse oplysninger i forbindelse med en ansættelse af en kundes privatforbrug.</p>
          
          <p><strong>Videregivelse til videnskabelige eller statistiske formål:</strong> Almindelige personoplysninger kan behandles til videnskabelige eller statistiske formål uden den registreredes samtykke på grundlag af databeskyttelsesforordningens § 6, stk. 1, litra e.</p>
          
          <p><strong>Yderligere kategorier af modtagere specifikt relateret til opladningstjenester:</strong></p>
          
          <p><strong>Installatør:</strong> I forbindelse med planlægning af installation vil kontaktoplysninger kunne videregives til en installatør.</p>
          
          <p>I forbindelse med behandling af personoplysninger benytter Leverandøren databehandlere til at understøtte levering af tjenester og drift af opladningssystemer. Alle databehandlere er underlagt databehandleraftaler, der sikrer overholdelse af lovgivningens krav, og Leverandøren gennemgår løbende disse samarbejdsaftaler for at sikre overholdelse af gældende regler.</p>
          
          <h2>7. Indsamling af oplysninger hos andre end den registrerede</h2>
          
          <p>Hvor det er relevant, indhenter Leverandøren personoplysninger om dig hos følgende kilder:</p>
          
          <p>Dig.</p>
          
          <p>Medlemmer af din husstand.</p>
          
          <p>Ejendomsmæglere, udlejere eller andre, som efter aftale med dig opretter dig som kunde hos os.</p>
          
          <p>Andre Leverandører via DataHub.</p>
          
          <p>Energinet.</p>
          
          <p>Kreditoplysningsbureauer.</p>
          
          <p>Offentlige myndigheder og/eller offentligt tilgængelige registre.</p>
          
          <h2>8. Overførsel til tredjelande</h2>
          
          <p>Vi kan overføre dine personoplysninger til databehandlere uden for EU og EØS, f.eks. it-support eller cloud-tjenester. Disse overførsler sker i overensstemmelse med gældende databeskyttelsesregler og anvender de nødvendige garantier, såsom standardkontraktbestemmelser.</p>
          
          <h2>9. Kundens rettigheder</h2>
          
          <h3>9.1. Kontaktoplysninger, hvis du vil benytte dine rettigheder</h3>
          
          <p>Såfremt du som kunde ønsker at gøre brug af nedenstående rettigheder, skal du kontakte Leverandøren gennem de kontaktoplysninger, som er oplistet øverst i privatlivspolitikken.</p>
          
          <p>Vi behandler og svarer din henvendelse så hurtigt som muligt og senest en måned, efter, at henvendelsen er modtaget, medmindre anmodningens kompleksitet og omfang gør, at der ikke kan svares inden for en måned. I så fald kan svarfristen blive op til 3 måneder i alt, jf. databeskyttelsesforordningens artikel 12.</p>
          
          <p>Du kan i øvrigt læse mere om dine rettigheder i Datatilsynets vejledning om de registreredes rettigheder, som du kan finde på www.datatilsynet.dk.</p>
          
          <h3>9.2. Ret til indsigt (se personoplysninger)</h3>
          
          <p>Du har ret til at få indsigt i de personoplysninger, som vi behandler om dig, samt en række yderligere oplysninger. Adgangen til indsigt må dog ikke krænke andres rettigheder og frihedsrettigheder.</p>
          
          <h3>9.3. Ret til berigtigelse (rettelse)</h3>
          
          <p>Du har ret til at få urigtige personoplysninger om dig selv rettet.</p>
          
          <h3>9.4. Ret til sletning af personoplysninger</h3>
          
          <p>I særlige tilfælde har du ret til at få slettet oplysninger om dig, inden tidspunktet for vores almindelige generelle sletning indtræffer.</p>
          
          <h3>9.5. Ret til begrænsning af behandling</h3>
          
          <p>Du har i visse tilfælde ret til at få behandlingen af dine personoplysninger begrænset. Hvis du har ret til at få begrænset behandlingen, må vi fremover kun behandle oplysningerne – bortset fra opbevaring – med dit samtykke, eller med henblik på, at retskrav kan fastlægges, gøres gældende eller forsvares, eller for at beskytte en person eller vigtige samfundsinteresser.</p>
          
          <h3>9.6. Indsigelse</h3>
          
          <p>Du har ret at til at gøre indsigelse imod Leverandørens behandling af dine personoplysninger, hvis behandling sker efter reglerne i databeskyttelsesforordningens artikel 6, stk. 1, litra e eller litra f, herunder profilering.</p>
          
          <p>Du har også ret til at gøre indsigelse imod Leverandørens behandling af dine personoplysninger, hvis behandlingen sker til direkte markedsføring, herunder profilering, jf. databeskyttelsesforordningens artikel 21. Efter en indsigelse må Leverandøren ikke længere behandle dine personoplysninger til dette formål.</p>
          
          <h3>9.7. Ret til at transmittere oplysninger (dataportabilitet)</h3>
          
          <p>Når vores behandling af dine personoplysninger baserer sig på samtykke eller en kontrakt, og behandlingen er foretaget automatisk, har du ret til dataportabilitet i forhold til oplysninger, som du selv har givet til Leverandøren.</p>
          
          <p>Denne ret indebærer, at du har ret til at få tilsendt de personoplysninger, som vi behandler om dig i et struktureret, almindeligt anvendt og maskinlæsbart format, som du har ret til at overføre til en anden tjenesteyder.</p>
          
          <h2>10. Klage</h2>
          
          <p>Såfremt du ønsker at klage over Leverandørens behandling af dine personoplysninger, har du ret til at indgive en klage til Datatilsynet, som har følgende kontaktoplysninger:</p>
          
          <p>Datatilsynet<br/>
          Adresse: Carl Jacobsens Vej 35, 2500 Valby<br/>
          E-mail: dt@datatilsynet.dk<br/>
          Telefonnr.: 3319 3200<br/>
          Hjemmeside: www.datatilsynet.dk</p>

          <h2>§ 11 — Behandling af elregninger via besparelsesberegner</h2>

          <p>Enkelt Energi ApS tilbyder besøgende på vores hjemmeside mulighed for at uploade en elregning med henblik på at beregne en potentiel besparelse ved skift til Enkelt Energi. Denne behandling sker uafhængigt af ethvert eksisterende kundeforhold.</p>

          <h3>Hvilke oplysninger behandles</h3>

          <p>Den uploadede fil kan indeholde personoplysninger som navn, adresse, aftagenummer, målenummer og forbrugsdata (kWh). Enkelt Energi ApS er dataansvarlig for denne behandling.</p>

          <h3>Formål og retsgrundlag</h3>

          <p>Formålet er udelukkende at beregne besparelsen og præsentere resultatet for den besøgende. Retsgrundlaget er den besøgendes udtrykkelige samtykke, jf. databeskyttelsesforordningens artikel 6, stk. 1, litra a. Samtykket afgives aktivt via en afkrydsningsboks inden upload.</p>

          <h3>Opbevaring og sletning</h3>

          <p>Den uploadede fil samt eventuelle udtrukne oplysninger slettes automatisk umiddelbart efter beregningen er gennemført. Der foretages ingen permanent lagring af filen eller dens indhold hos Enkelt Energi ApS.</p>

          <h3>Databehandlere og overførsler</h3>

          <p>Behandlingen sker via følgende databehandlere, som alle er underlagt databehandleraftaler med Enkelt Energi ApS:</p>
          <ul>
            <li>Base44 Inc. (USA) — applikationsplatform og filhåndtering</li>
            <li>Anthropic Inc. (USA) — AI-baseret tekstekstraktion via Claude API</li>
          </ul>
          <p>Overførsler til USA sker på grundlag af EU-standardkontraktbestemmelser (SCC), jf. Kommissionens gennemførelsesafgørelse (EU) 2021/914.</p>

          <h3>Videregivelse</h3>

          <p>Oplysningerne videregives ikke til tredjeparter i forbindelse med denne behandling ud over de nævnte databehandlere.</p>

          <h3>Tilbagetrækning af samtykke</h3>

          <p>Den besøgende kan til enhver tid trække sit samtykke tilbage ved at kontakte os på hej@enkelenergi.dk. Da filen slettes automatisk efter behandling, vil tilbagetrækning ikke have praktisk betydning for allerede gennemførte beregninger.</p>

          <h2>§ 12 — Behandling af forbrugsdata via Eloverblik</h2>

          <p>Enkelt Energi ApS tilbyder besøgende på vores hjemmeside mulighed for at forbinde via Eloverblik med henblik på at hente forbrugsdata fra Energinets datahub til brug for beregning af en potentiel besparelse. Denne behandling sker uafhængigt af ethvert eksisterende kundeforhold.</p>

          <h3>Hvilke oplysninger behandles</h3>

          <p>Følgende oplysninger hentes via Energinets datahub på baggrund af den besøgendes Eloverblik-token:</p>
          <ul>
            <li>Timeforbrug i kWh (forbrugsdata)</li>
            <li>Aftagenummer, målernummer, målerpunkttype og netområdekode</li>
            <li>Adresseoplysninger: vejnavn, husnummer, postnummer og by</li>
            <li>Netselskab og nuværende elleverandørs navn</li>
            <li>Estimeret årligt forbrug</li>
          </ul>
          <p><em>Spot- og tarifpriser hentes fra Energidataservice, som er en offentlig API, der ikke indeholder personoplysninger.</em></p>

          <h3>Formål og retsgrundlag</h3>

          <p>Formålet er udelukkende at beregne besparelsen og præsentere resultatet for den besøgende. Retsgrundlaget er den besøgendes udtrykkelige samtykke, jf. databeskyttelsesforordningens artikel 6, stk. 1, litra a. Samtykket afgives aktivt via en afkrydsningsboks inden forbindelsen etableres.</p>

          <h3>Behandlingens karakter og sletning</h3>

          <p>Den besøgendes Eloverblik-token anvendes én gang til at indhente et midlertidigt adgangstoken. Herefter behandles alle data udelukkende i serverens arbejdshukommelse som et led i den enkelte forespørgsel og er ikke tilgængelige efter forespørgslen er afsluttet. På klientsiden opbevares data udelukkende i browserens arbejdshukommelse (React state) og forsvinder automatisk, når brugeren forlader eller genindlæser siden.</p>

          <p>Der foretages ingen skrivning til databaser, cookies, localStorage eller andre persistente lagringsmedier.</p>

          <h3>Databehandlere og overførsler</h3>

          <p>Behandlingen sker via følgende databehandlere, som alle er underlagt databehandleraftaler med Enkelt Energi ApS:</p>
          <ul>
            <li>Base44 Inc. (USA) — applikationsplatform og serverinfrastruktur</li>
            <li>Energinet (Danmark) — datahub, den nationale infrastruktur for elmålerdata</li>
          </ul>
          <p>Overførsler til USA via Base44 Inc. sker på grundlag af EU-standardkontraktbestemmelser (SCC), jf. Kommissionens gennemførelsesafgørelse (EU) 2021/914. Data hentes fra Energinets datahub, som er beliggende i Danmark.</p>

          <h3>Videregivelse</h3>

          <p>Oplysningerne videregives ikke til tredjeparter i forbindelse med denne behandling ud over de nævnte databehandlere.</p>

          <h3>Tilbagetrækning af samtykke</h3>

          <p>Den besøgende kan til enhver tid trække sit samtykke tilbage ved at kontakte os på hej@enkelenergi.dk. Da der ikke gemmes data efter sessionen, vil tilbagetrækning ikke have praktisk betydning for allerede gennemførte beregninger.</p>

        </div>
      </div>
    </div>
  );
}